var map = {
	"./af.json": 9383,
	"./am.json": 11726,
	"./ar.json": 55699,
	"./az.json": 73963,
	"./be.json": 10749,
	"./bg.json": 86031,
	"./bn.json": 95808,
	"./br.json": 27924,
	"./bs.json": 93723,
	"./ca.json": 77552,
	"./cs.json": 50470,
	"./cy.json": 47768,
	"./da.json": 98159,
	"./de.json": 29419,
	"./dv.json": 62602,
	"./el.json": 85521,
	"./en.json": 74275,
	"./es.json": 2072,
	"./et.json": 54521,
	"./eu.json": 66074,
	"./fa.json": 20149,
	"./fi.json": 42829,
	"./fr.json": 69792,
	"./ga.json": 87148,
	"./gl.json": 82191,
	"./ha.json": 84667,
	"./he.json": 19807,
	"./hi.json": 48099,
	"./hr.json": 19373,
	"./hu.json": 76975,
	"./hy.json": 88979,
	"./id.json": 43005,
	"./is.json": 86100,
	"./it.json": 51245,
	"./ja.json": 22209,
	"./ka.json": 55544,
	"./kk.json": 58246,
	"./km.json": 83148,
	"./ko.json": 99906,
	"./ku.json": 27284,
	"./ky.json": 85328,
	"./lt.json": 46908,
	"./lv.json": 86386,
	"./mk.json": 77768,
	"./ml.json": 59529,
	"./mn.json": 28059,
	"./mr.json": 14967,
	"./ms.json": 24544,
	"./mt.json": 92705,
	"./nb.json": 14648,
	"./nl.json": 14210,
	"./nn.json": 96460,
	"./no.json": 62835,
	"./pl.json": 43144,
	"./ps.json": 29505,
	"./pt.json": 69856,
	"./ro.json": 11079,
	"./ru.json": 53021,
	"./sd.json": 37811,
	"./sk.json": 21630,
	"./sl.json": 19723,
	"./so.json": 64794,
	"./sq.json": 43216,
	"./sr.json": 91701,
	"./sv.json": 84241,
	"./sw.json": 98162,
	"./ta.json": 83999,
	"./tg.json": 2697,
	"./th.json": 8560,
	"./tk.json": 35221,
	"./tr.json": 98686,
	"./tt.json": 75716,
	"./ug.json": 39108,
	"./uk.json": 32320,
	"./ur.json": 36319,
	"./uz.json": 19495,
	"./vi.json": 413,
	"./zh.json": 83274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83824;